import type {LazyQueryExecFunction} from '@apollo/client';

import {useRestLazyQuery} from '@famly/stat_apollo-query';
import type {FetchPlanWarningsResponse} from 'web-app/api/clients/rest-types/fetch-plan-warnings-for-child/fetch-plan-warnings-for-child-query';
import type {FetchPlanWarningsVariables} from 'web-app/api/clients/rest-types/fetch-plan-warnings-for-child/fetch-plan-warnings-for-child-variables';

import {FetchPlanWarningsQuery} from '../queries/fetch-plan-warnings.rest-query';

export type PlanWarnings = {
    fetchPlanWarnings: LazyQueryExecFunction<FetchPlanWarningsResponse, FetchPlanWarningsVariables>;
    isWarningsLoading: boolean;
};

export const useFetchPlanWarnings = (): PlanWarnings => {
    const [fetchPlanWarnings, {loading: isWarningsLoading}] = useRestLazyQuery<
        FetchPlanWarningsResponse,
        FetchPlanWarningsVariables
    >(FetchPlanWarningsQuery, {
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-and-network',
    });

    return {fetchPlanWarnings, isWarningsLoading};
};
